import React, { useCallback, useEffect, useState } from 'react';
import styled from 'styled-components';
import PeriodType, { PeriodTypeProps } from './PeriodType';
import NewProgram from '../../../ReportsBeta/NewProgram';
import { useGraphQLRequest } from 'shared/auth/hooks/useApiRequest';
import { NPOUser, getAllNPOUsers } from '../../../ReportsBeta/NewProgram/api';
import { Program } from '../../../Reports/NewReportDialog';
import { getPrograms } from '../../../ReportsBeta/NewReport/api';
import { useClient } from 'shared/apollo';

interface ProgramImplementationProps extends PeriodTypeProps {
  openProgramOnOptionText: string;
}

const StyledDiv = styled.div``;

const ProgramImplementation: React.FC<ProgramImplementationProps> = ({
  getOptionDetails,
  pageOptionProps,
  questionId,
  haveExtraDetails,
  openProgramOnOptionText,
}) => {
  const client = useClient();
  const [
    programsList,
    makeProgramsListRequest,
    setProgramsList,
  ] = useGraphQLRequest<{
    allPrograms: Program[];
  }>();
  const [allNPOUsers, makeAllNPOUsersRequest] = useGraphQLRequest<{
    allUsers: NPOUser[];
  }>();

  const reloadProgramList = useCallback(() => {
    makeProgramsListRequest(getPrograms(client!));
  }, [setProgramsList]);

  const [show, setShow] = useState<boolean>(
    pageOptionProps.getSelected(openProgramOnOptionText),
  );

  const handleClose = useCallback(() => {
    setShow(false);
  }, [setShow]);

  const handleClick = useCallback(
    (value: string) => {
      pageOptionProps.onClick(value);
      if (value === openProgramOnOptionText) {
        setShow(true);
      }
    },
    [setShow],
  );

  useEffect(() => {
    if (!client) return;
    makeProgramsListRequest(getPrograms(client));
    makeAllNPOUsersRequest(getAllNPOUsers(client));
  }, [client]);

  return (
    <StyledDiv>
      <PeriodType
        haveExtraDetails={haveExtraDetails}
        questionId={questionId}
        pageOptionProps={{ ...pageOptionProps, onClick: handleClick }}
        getOptionDetails={getOptionDetails}
      />
      {show && (
        <NewProgram
          open={true}
          allNPOUsers={allNPOUsers}
          programsList={programsList}
          reloadProgramList={reloadProgramList}
          onClose={handleClose}
        />
      )}
    </StyledDiv>
  );
};

export default ProgramImplementation;
